import type { RouteObject } from "react-router";
import { InternSicherheit } from "../intern/Bereich";
import { BetriebRahmen } from "./Rahmen";
import { Agenturen } from "./Agenturen";
import { AgenturDetail } from "./AgenturDetail";
import { Support } from "./Support";
import { Plattform } from "./Betriebsdaten";
import { Antraege } from "./Verwaltung";
import { Ueberwachung } from "./Ueberwachung";
import { Fehlermeldungen, FehlermeldungDetail, KiProtokoll, TicketBearbeiten, Tickets } from "./SupportTickets";
import { Rechtstexte } from "./Rechtstexte";
import { KiZugaenge } from "./KiZugaenge";
import { Rabattcodes } from "./Rabattcodes";
import { Rechnungszahlung } from "./Rechnungszahlung";
import { KuendigungswegBetrieb } from "./Kuendigungsweg";
import { BasiszinsSeite, KonsoleMehr, KonsoleStart, TrafficSeite } from "./Start";
import { Instagram } from "./Instagram";
import { DemoTermine } from "./DemoTermine";
import { Team } from "./Team";
import { Pipeline } from "./Pipeline";
import { Leads } from "./Leads";
import { LeadAkte } from "./LeadAkte";
import { DemoKontoSeite } from "./DemoKonto";
import { KonsoleKalender } from "./Kalender";

/**
 * Betreiber-Konsole im internen Bereich unter /intern (Zugangsprüfung: InternArea in pages/intern/Bereich.tsx, eigene Sitzung;
 * jede Abfrage prüft die Datenbank erneut). Alte Adressen /betrieb/… leiten um.
 * Die Seiten teilen sich den Rahmen (Rahmen.tsx: Portal-Design mit Seitenleiste nach Rolle, Suche, Hinweise). Welche Rolle
 * welche Seite öffnet, steht in konsole-nav.ts; die Einladung ins Team (/intern/einladung) liegt vor dem Zugangstor.
 */
export const betriebRoutes: RouteObject[] = [
  {
    element: <BetriebRahmen />,
    children: [
      // Anmeldung & Sicherheit der internen Sitzung (zweiter Faktor), für jede Rolle
      { path: "sicherheit", element: <InternSicherheit /> },
      // 0213: Kacheln, Verlauf, Weg zum zahlenden Kunden, „Braucht Aufmerksamkeit“; Vertrieb-Konsole (02.11.2026): Start je Rolle
      { index: true, element: <KonsoleStart /> },
      // Vertrieb-Konsole: Website-Traffic (Marketing) und Basiszins (Technik) als eigene Seiten, „Mehr“ am Handy
      { path: "traffic", element: <TrafficSeite /> },
      { path: "basiszins", element: <BasiszinsSeite /> },
      { path: "mehr", element: <KonsoleMehr /> },
      // 0530: Team-Kalender (Tag, Woche, Monat; mein Kalender oder Team; Abo-Link je Person)
      { path: "kalender", element: <KonsoleKalender /> },
      // 0460: Vertrieb (Pipeline nach Stufen, Leadliste mit Filtern, Lead-Akte)
      { path: "pipeline", element: <Pipeline /> },
      { path: "leads", element: <Leads /> },
      { path: "leads/:id", element: <LeadAkte /> },
      // 0461: Demo-Konto öffnen, zurücksetzen, Ausgangsstand speichern
      { path: "demo", element: <DemoKontoSeite /> },
      { path: "agenturen", element: <Agenturen /> },
      { path: "agenturen/:orgId", element: <AgenturDetail /> },
      { path: "support", element: <Support /> },
      { path: "antraege", element: <Antraege /> },
      { path: "plattform", element: <Plattform /> },
      // 0101: Zeitpläne, Serverfunktionen, Mailversand
      { path: "ueberwachung", element: <Ueberwachung /> },
      // 0176: gemeldete Fehler und Tickets der Agenturen
      { path: "fehler", element: <Fehlermeldungen /> },
      { path: "fehler/:id", element: <FehlermeldungDetail /> },
      { path: "tickets", element: <Tickets /> },
      { path: "tickets/:id", element: <TicketBearbeiten /> },
      // 0177: Aktionen des Betreiber-Zugangs für Claude
      { path: "ki-protokoll", element: <KiProtokoll /> },
      // 0204: Schlüssel für Claude, ChatGPT und andere (Serverfunktion ki-api)
      { path: "ki-zugaenge", element: <KiZugaenge /> },
      // 0205: Rabattcodes (Stripe-Coupon und Promotion Code)
      { path: "rabattcodes", element: <Rabattcodes /> },
      // 0590: Abo auf Rechnung (Bankverbindung, Rechnungen, Zahlung von Hand verbuchen, Zahlungseingänge)
      { path: "zahlung-auf-rechnung", element: <Rechnungszahlung /> },
      // 0415: Halte-Quote des Kündigungswegs je Schritt, Grund und Angebot
      { path: "kuendigungsweg", element: <KuendigungswegBetrieb /> },
      // 0227: Nachrichten des eigenen Instagram-Kontos (nur lesen)
      { path: "instagram", element: <Instagram /> },
      // 0390: Demo-Termine freigeben, Buchungen der Website (creatoroffice.de/demo)
      { path: "demo-termine", element: <DemoTermine /> },
      // 0182: Fassungen der Rechtstexte, Ankündigung von Änderungen und neuen Unterauftragsverarbeitern
      { path: "rechtstexte", element: <Rechtstexte /> },
      // 0459 (Vertrieb-Konsole, Inhaber 02.11.2026): Mitarbeiter einladen, Rolle, deaktivieren (nur Admin)
      { path: "team", element: <Team /> },
    ],
  },
];
